import { render, staticRenderFns } from "./RequestLinks.vue?vue&type=template&id=dd0fa1a0&scoped=true&"
import script from "./RequestLinks.vue?vue&type=script&lang=js&"
export * from "./RequestLinks.vue?vue&type=script&lang=js&"
import style0 from "./RequestLinks.vue?vue&type=style&index=0&id=dd0fa1a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0fa1a0",
  null
  
)

export default component.exports